module.exports = __webpack_public_path__ + "static/media/arrow-drop-down-left.ce1d3d07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-drop-down-left.svg
// module id = 1248
// module chunks = 1